import { HTMLParserHelper } from "../../helper/HTMLParserHelper";
import { Link } from "react-router-dom";
const News = ({ data }) => {
  return (
    <div className="container-fluid news_bg">
      {" "}
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 home_news">
          <div className="container news_padding">
            {" "}
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="section_title pull-left">In the News</div>
                <span className="read_more pull-right">
                  {data.news && <Link to="/news/">More News</Link>}
                </span>
              </div>
            </div>
            {data.news && (
              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 news_content">
                  <div className="circle">
                    <span className="ndate">
                      {new Date(data.news[0].date).getDate()}
                    </span>
                    <span className="nmonth">
                      {new Date(data.news[0].date).toLocaleString("default", {
                        month: "short",
                      })}
                    </span>
                  </div>
                  <div className="news_title pull-left">
                    <a target="_self" href={data.news[0].url}>
                      {HTMLParserHelper(data.news[0].title)}
                    </a>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 news_content">
                  <div className="circle">
                    <span className="ndate">
                      {new Date(data.news[1].date).getDate()}
                    </span>
                    <span className="nmonth">
                      {new Date(data.news[1].date).toLocaleString("default", {
                        month: "short",
                      })}
                    </span>
                  </div>
                  <div className="news_title pull-left">
                    <a target="_self" href={data.news[1].url}>
                      {HTMLParserHelper(data.news[1].title)}
                    </a>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 news_content">
                  <div className="circle">
                    <span className="ndate">
                      {new Date(data.news[2].date).getDate()}
                    </span>
                    <span className="nmonth">
                      {new Date(data.news[2].date).toLocaleString("default", {
                        month: "short",
                      })}
                    </span>
                  </div>
                  <div className="news_title pull-left">
                    <a target="_self" href={data.news[2].url}>
                      {HTMLParserHelper(data.news[2].title)}
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>{" "}
        </div>
      </div>
    </div>
  );
};
export default News;
